/**
 * Generates the styles for hiding the Google reCaptcha badge.
 *
 * @return {string} The CSS styles for hiding the Google reCaptcha badge.
 */
export const generateGoogleReCaptchaHiddenBadgeStyles = () =>
  '.grecaptcha-badge{display: none !important;}';
